import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

type Tone = 'danger' | 'success' | 'info'

const tones: Record<Tone, string> = {
  danger: 'bg-danger-soft text-danger',
  success: 'bg-brand-light text-brand-darker',
  info: 'bg-surface-muted text-ink-soft',
}

interface AlertProps {
  tone?: Tone
  children: ReactNode
  className?: string
  /** Centraliza o texto — formato da tarja larga usada no topo das páginas. */
  centered?: boolean
}

export function Alert({ tone = 'danger', children, className, centered }: AlertProps) {
  return (
    <div
      // `alert` faz o leitor de tela anunciar o erro assim que ele aparece.
      role={tone === 'danger' ? 'alert' : 'status'}
      className={cn(
        'w-full px-4 py-3 text-sm font-semibold',
        tones[tone],
        centered && 'text-center',
        className,
      )}
    >
      {children}
    </div>
  )
}
